import { render, staticRenderFns } from "./CustomImage.vue?vue&type=template&id=5d0b9098&scoped=true&"
import script from "./CustomImage.vue?vue&type=script&lang=js&"
export * from "./CustomImage.vue?vue&type=script&lang=js&"
import style0 from "./CustomImage.vue?vue&type=style&index=0&id=5d0b9098&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b9098",
  null
  
)

export default component.exports